import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanStructureUpdateModalUI from './LoanStructureUpdateModalUI.js'

class LoanStructureUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form fields 
      pledgeOrNdu: this.props.loan.pledgeOrNdu || '',
      pledgeOrNduError: null,
      escrow: this.props.loan.escrow || '',
      escrowError: null,
      specialTerms: (this.props.loan.specialTerms).toString() || '',
      specialTermsError: null,
      boardMeetingDate: this.props.loan.resolutionSign.boardMeetingDateISO || '',
      boardMeetingDateError: null,
      shareholderMeetingDate: this.props.loan.resolutionSign.shareholderMeetingDateISO || '',
      shareholderMeetingDateError: null,
    }
  }

  render() {
    let pledgeOrNduList = [
      { key: 'pledge', value: 'Pledge' },
      { key: 'ndu', value: 'NDU' },
    ]
    let escrowTypeList = [
      { key: 'b2b', value: 'B2B' },
      { key: 'b2c', value: 'B2C' },
      { key: 'na', value: 'NA' },
    ]
    let booleanList = [
      { key: 'true', value: 'Yes' },
      { key: 'false', value: 'No' },
    ]
    return (
      <LoanStructureUpdateModalUI
        context={this.props.context}
        loan={this.props.loan}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields 
        pledgeOrNdu={this.state.pledgeOrNdu}
        onPledgeOrNduChange={(event) => { this.setState({ pledgeOrNdu: event.target.value }) }}
        pledgeOrNduError={this.state.pledgeOrNduError}
        setPledgeOrNduError={(error) => { this.setState({ pledgeOrNduError: error }) }}
        pledgeOrNduList={pledgeOrNduList}
        //
        escrow={this.state.escrow}
        onEscrowChange={(event) => { this.setState({ escrow: event.target.value }) }}
        escrowError={this.state.escrowError}
        setEscrowError={(error) => { this.setState({ escrowError: error }) }}
        escrowTypeList={escrowTypeList}
        //
        specialTerms={this.state.specialTerms}
        onSpecialTermsChange={(event) => { this.setState({ specialTerms: event.target.value }) }}
        specialTermsError={this.state.specialTermsError}
        setSpecialTermsError={(error) => { this.setState({ specialTermsError: error }) }}
        booleanList={booleanList}
        //
        boardMeetingDate={this.state.boardMeetingDate}
        onBoardMeetingDateChange={(boardMeetingDate) => { this.setState({ boardMeetingDate }) }}
        boardMeetingDateError={this.state.boardMeetingDateError}
        setBoardMeetingDateError={(error) => { this.setState({ boardMeetingDateError: error }) }}
        //
        shareholderMeetingDate={this.state.shareholderMeetingDate}
        onShareholderMeetingDateChange={(shareholderMeetingDate) => { this.setState({ shareholderMeetingDate }) }}
        shareholderMeetingDateError={this.state.shareholderMeetingDateError}
        setShareholderMeetingDateError={(error) => { this.setState({ shareholderMeetingDateError: error }) }}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/loanStructure`,
      this.onSubmitCallback, {
      pledgeOrNdu: this.state.pledgeOrNdu,
      escrow: this.state.escrow,
      specialTerms: this.state.specialTerms,
      boardMeetingDate: this.state.boardMeetingDate,
      shareholderMeetingDate: this.state.shareholderMeetingDate
    })
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default LoanStructureUpdateModalSF
